// import { POST } from '@/services/Api'
import { CreateZoneURL, DeleteZoneURL, UpdateZoneURL, ListZoneURL } from '@/consts/consts'
import {POST} from "@/utils/request/request";


export function CreateZone(data) {
  return POST(CreateZoneURL, data)
}

export function DeleteZone(data) {
  return POST(DeleteZoneURL, data)
}

export function UpdateZone(data) {
  return POST(UpdateZoneURL, data)
}

export function ListZone(data) {
  return POST(ListZoneURL, data)
}
